import AppointmentType from '@/components/AppointmentType/AppointmentType';
import Alert from '@/ui/components/Alert';
import LoadingSkeleton from '@/ui/components/LoadingSkeleton';

import { Props } from './types';

const PageTemplate = ({
  activeAppointmentTypeId,
  isLoading,
  isError,
  error,
  data,
  onSeeExpectationDetails,
  phase,
  timeZone,
  uiMode
}: Props) => {
  return isLoading ? (
    <LoadingSkeleton />
  ) : isError ? (
    <Alert level="error">
      Failed to load schedule expectation cycles.
      {error?.message && error.message}
    </Alert>
  ) : data?.length === 0 ? (
    <div>No schedule expectation cycles found for this phase.</div>
  ) : (
    <div className="space-y-4">
      {data?.map((appointmentType) => (
        <AppointmentType
          key={`${appointmentType.appointment_type_id}-${appointmentType.appointment_type_id === activeAppointmentTypeId}`}
          appointmentType={appointmentType}
          isActive={appointmentType.appointment_type_id === activeAppointmentTypeId}
          onSeeExpectationDetails={onSeeExpectationDetails}
          phase={phase}
          timeZone={timeZone}
          uiMode={uiMode}
        />
      ))}
    </div>
  );
};

export default PageTemplate;
